import React from 'react';
import { Icon } from '../../../utilities/icomoon-css';
import { useVariant } from '../hooks/VariantContext';
import { ContactUsPageTypes } from '../ContactUsPageTypes';
import { IconConfig } from '../../contactUsPage/helpers/constants';

type TIconsHelper = {
  iconsConfig: ContactUsPageTypes.TIconSection;
  allIconsColor?: ContactUsPageTypes.TColorType;
};

export const IconsHelper = ({ iconsConfig }: TIconsHelper) => {
  const { iconClassName } = iconsConfig;
  const variant = useVariant();
  return (
    <span className="iconContainer">
      {iconClassName && (
        <Icon
          name={iconClassName}
          color={variant === 'newContactUsDarkTheme' ? 'white' : '#525E75'}
          size={IconConfig.iconSizeContactUs}
        />
      )}
    </span>
  );
};
